import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';

export interface DrawerMobileTemplateContext {
  setDrawerMobileTemplate: Dispatch<SetStateAction<ReactElement | undefined>>;
  drawerMobileTemplate: ReactElement;
}

export const DrawerMobileTemplateContext = createContext<DrawerMobileTemplateContext | undefined>(undefined);

export const DrawerMobileTemplateContextProvider = (props: any) => {
  const [drawerMobileTemplate, setDrawerMobileTemplate] = useState<ReactElement | undefined>(undefined);

  return (
    <DrawerMobileTemplateContext.Provider value={{ drawerMobileTemplate, setDrawerMobileTemplate }} {...props}>
      {props.children}
    </DrawerMobileTemplateContext.Provider>
  );
};
